import { Download } from "lucide-react"

// Escapes a value for one CSV field per RFC 4180: wrap in quotes if it
// contains a comma, quote or newline, doubling any embedded quotes.
const csvCell = (value) => {
  const s = value == null ? "" : String(value)
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
}

const toCsv = (rows, columns) => {
  const header = columns.map((c) => csvCell(c.label)).join(",")
  const body = rows.map((r) => columns.map((c) => csvCell(c.value(r))).join(",")).join("\n")
  return `${header}\n${body}`
}

// Exports the rows currently shown in a ProcurementTable to a CSV file,
// client-side — no backend export endpoint required. `columns` is a plain
// [{ label, value(row) }] list, independent from the table's JSX column defs
// so any page can reuse this without exposing its render functions.
export const ExportButton = ({ rows = [], columns = [], filename = "export.csv", label = "Export", disabled }) => {
  const handleExport = () => {
    const csv = toCsv(rows, columns)
    const blob = new Blob([`﻿${csv}`], { type: "text/csv;charset=utf-8;" })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(url)
  }

  return (
    <button
      type="button"
      className="pc-btn pc-btn--secondary pc-btn--sm"
      onClick={handleExport}
      disabled={disabled || rows.length === 0}
    >
      <Download aria-hidden />
      {label}
    </button>
  )
}

export default ExportButton
